import AdministracaoDetalheService from "./AdministracaoDetalheService";
import axios from "axios";

export default {
  mixins: [AdministracaoDetalheService],
  data() {
    return {
      // DETALHES
      codigoUnimed: 0,
      mostrarModalHistoricos: false,
      objetoInformacoes: {
        codigoUnimed: "",
        nomeUnimed: "",
        analistaResponsavel: "",
        emailResponsavel: ""
      },
      objetoDataNotificacao: {
        primeiroDia: "",
        segundoDia: ""
      },
      objetoClassificacao: {
        dataDeixouDeSerOperadora: "",
        tipoAtuacao: "",
        dataDeixouDeSerOperadoraEdit: "",
        tipoAtuacaoEdit: ""
      },
      objetoClassificacaoToSave: {
        dataDeixouDeSerOperadora: "",
        tipoAtuacao: "",
        motivoAlteracao: "",
        admUnimedHistoricoClassificacao: []
      },
      loadingInformacoes: false,
      listaTipoAtuacao: [
        { descTipoAtuacao: "OPERADORA" },
        { descTipoAtuacao: "NÃO OPERADORA" },
        { descTipoAtuacao: "INSTITUCIONAL" },
        { descTipoAtuacao: "NÃO SE APLICA" }
      ],
      mostrarModalClassificJustif: false,
      mostrarModalHistoricoClassific: false,

      // ANALISTAS
      mostrarModalAnalista: false,
      tipoAcaoModalAnalista: "ADICIONAR",
      idUsuarioUnimedGiu: null,
      listagemAnalista: [],
      objetoAnalistaAtual: {},

      // CONTATOS
      listagemContatos: [],
      listagemContatosExcluidos: [],
      loadingContatos: false,
      loadingContatosExcluidos: false,
      mostrarModalContatos: false,
      tipoAcaoModalContatos: "ADICIONAR",
      idSelecionadoContatos: 0,
      valoresSwitchProp: [],

      // OBSERVAÇÕES
      mostrarMenuObservacao: false,
      offsetObservacao: 10,
      numeroAdicionalOffset: 10
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.inicializarVariaveis();
      this.loadingInformacoes = true;

      this.inicializarContatos().finally(() => {
        this.inicializarObservacoes().finally(() => {
          this.inicializarDetalhe().then(podeEditarAnalistas => {
            if (!podeEditarAnalistas) {
              this.loadingInformacoes = false;
              return;
            }
            this.inicializarAnalistas().finally(() => {
              this.loadingInformacoes = false;
            });
          });
        });
      });
    },
    inicializarVariaveis() {
      this.codigoUnimed = this.$route.params.id;
      this.$store.commit("setCodigoUnimedObservacao", this.codigoUnimed);
    },

    // DETALHES

    /**
     * Simples wrapper pra exibir loading
     */
    carregarDetalhes() {
      this.loadingInformacoes = true;
      this.inicializarDetalhe().finally(() => {
        this.loadingInformacoes = false;
      });
    },
    /**
     * Serve para popular informações da unimed, tais como: nome, código,
     * nome do analista, email do analista, primeiro dia e segundo dia, tipo de atuação
     */
    inicializarDetalhe() {
      return new Promise((resolve, reject) => {
        this.getDetalheUnimed(this.codigoUnimed)
          .then(res => {
            let nomeAnalista = null,
              emailAnalista = null,
              idUsuarioUnimedGiu = null;

            const {
              analista,
              cdUnimed,
              primeiroDia,
              segundoDia,
              textoExibicao,
              podeEditarAnalistas,
              dataDeixouDeSerOperadora,
              tipoAtuacao
            } = res.data;

            if (analista !== null) {
              nomeAnalista = analista.nomeAnalista;
              emailAnalista = analista.emailAnalista;
              idUsuarioUnimedGiu = analista.idUsuarioUnimedGiu;
            }

            // Informações do primeiro card
            this.objetoInformacoes = {
              codigoUnimed: cdUnimed,
              nomeUnimed: textoExibicao,
              analistaResponsavel: nomeAnalista,
              emailResponsavel: emailAnalista,
              podeEditarAnalistas
            };

            // Informações do último card
            this.objetoDataNotificacao = {
              primeiroDia: primeiroDia ? primeiroDia : "",
              segundoDia: segundoDia ? segundoDia : ""
            };

            let tipoAtuacaoAux = null;
            tipoAtuacaoAux = this.listaTipoAtuacao.find(
              ta => ta.descTipoAtuacao === tipoAtuacao
            );

            this.objetoClassificacao = {
              dataDeixouDeSerOperadora: dataDeixouDeSerOperadora
                ? this.$helpers.formatadorISO(
                    dataDeixouDeSerOperadora,
                    "DD/MM/YYYY",
                    "YYYY-MM-DD"
                  )
                : "",
              tipoAtuacao: tipoAtuacaoAux ? tipoAtuacaoAux : "",
              dataDeixouDeSerOperadoraEdit: dataDeixouDeSerOperadora
                ? this.$helpers.formatadorISO(
                    dataDeixouDeSerOperadora,
                    "DD/MM/YYYY",
                    "YYYY-MM-DD"
                  )
                : "",
              tipoAtuacaoEdit: tipoAtuacaoAux ? tipoAtuacaoAux : ""
            };

            this.idUsuarioUnimedGiu = idUsuarioUnimedGiu;
            resolve(podeEditarAnalistas);
          })
          .catch(() => {
            reject();
          });
      });
    },
    /**
     * É chamada no clique do botão de salvar as datas para notificação
     * @param {{ primeiroDia: "", segundoDia: "" }} objetoDataNotificacao
     */
    salvarData(objetoDataNotificacao) {
      this.$store.commit("setLoadingModal", true);
      this.putDetalheUnimed(this.codigoUnimed, objetoDataNotificacao)
        .then(() => {
          const { primeiroDia, segundoDia } = objetoDataNotificacao;
          let subtitulo = "";

          if (primeiroDia > 28 || segundoDia > 28) {
            subtitulo = `Em meses com dias inferiores a ${
              primeiroDia >= segundoDia ? primeiroDia : segundoDia
            }, as notificações serão antecipadas.`;
          } else {
            subtitulo = "Datas editadas com sucesso.";
          }
          this.$store.commit("setSubtituloSucesso", subtitulo);
          this.$store.commit("setMostrarSucessoModal", true);
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.carregarDetalhes();
          });
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    adicionarObservacao() {
      this.mostrarMenuObservacao = true;
    },
    mostrarObservacao() {
      this.mostrarMenuObservacao = true;
    },

    /**
     * É chamada para abrir o modal de jusficativa alteração do tipo de atuação
     * e montar o histórico de alteração
     * @param {{dataDeixouDeSerOperadora: "", tipoAtuacao: "", motivoAlteracao: ""}} objetoClassificacaoParam
     */
    abrirModalClassificacaoJustificativa(objetoClassificacaoParam) {
      let dataDeixouDeSerOperadoraAux = null;

      if (
        objetoClassificacaoParam.tipoAtuacaoEdit.descTipoAtuacao !==
        "NÃO OPERADORA"
      ) {
        dataDeixouDeSerOperadoraAux = "";
      } else {
        dataDeixouDeSerOperadoraAux = this.$helpers.formatadorISO(
          objetoClassificacaoParam.dataDeixouDeSerOperadoraEdit,
          "YYYY-MM-DD",
          "DD/MM/YYYY"
        );
        dataDeixouDeSerOperadoraAux = new Date(
          dataDeixouDeSerOperadoraAux
        ).toISOString();
      }

      this.objetoClassificacaoToSave = {
        dataDeixouDeSerOperadora: dataDeixouDeSerOperadoraAux,
        tipoAtuacao: objetoClassificacaoParam.tipoAtuacaoEdit.descTipoAtuacao
      };

      const dataAtual = new Date();
      dataAtual.setUTCHours(dataAtual.getUTCHours() - 3);
      if (
        objetoClassificacaoParam.tipoAtuacao.descTipoAtuacao !==
          objetoClassificacaoParam.tipoAtuacaoEdit.descTipoAtuacao ||
        objetoClassificacaoParam.dataDeixouDeSerOperadora !==
          objetoClassificacaoParam.dataDeixouDeSerOperadoraEdit
      ) {
        this.objetoClassificacaoToSave.admUnimedHistoricoClassificacao = [];
        this.objetoClassificacaoToSave.admUnimedHistoricoClassificacao.push({
          nomeUsuarioAlteracao: this.nomeUsuarioMixin,
          dataAlteracao: dataAtual,
          valorAntigoCampo:
            objetoClassificacaoParam.tipoAtuacao.descTipoAtuacao,
          valorNovoCampo:
            objetoClassificacaoParam.tipoAtuacaoEdit.descTipoAtuacao
        });

        this.$refs["modal-classific-justific"].editarObjetoClassificacao(
          this.objetoClassificacaoToSave
        );
        this.mostrarModalClassificJustif = true;
      }
    },
    salvarAlteracaoClassificacao(objetoClassificacaoToSave) {
      objetoClassificacaoToSave.admUnimedHistoricoClassificacao[0].motivoAlteracao =
        objetoClassificacaoToSave.motivoAlteracao;

      this.$store.commit("setLoadingModal", true);
      this.putClassificacaoUnimed(this.codigoUnimed, objetoClassificacaoToSave)
        .then(() => {
          this.$store.commit(
            "setSubtituloSucesso",
            "Classificação alterada com sucesso"
          );
          this.$store.commit("setMostrarSucessoModal", true);
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.carregarDetalhes();
          });
        })
        .finally(() => {
          this.mostrarModalClassificJustif = false;
          this.$store.commit("setLoadingModal", false);
        });
    },
    abrirModalHistoricoClassific() {
      this.recuperarHistoricoClassific(this.codigoUnimed)
        .then(res => {
          this.$refs["modal-historicos-classific"].montarTabela(
            res.data,
            this.codigoUnimed
          );
          this.mostrarModalHistoricoClassific = true;
        })
        .finally(() => {});
    },
    recuperarHistoricoClassific(codigoUnimed) {
      return axios.get(
        this.CriarUrl({
          resource: `adm/unimeds/classific/historico/${codigoUnimed}`
        })
      );
    },

    // ANALISTAS
    /**
     * Recupera a lista com os analistas
     * @return {Promise<null>}
     */
    inicializarAnalistas() {
      return new Promise((resolve, reject) => {
        this.getAnalistasUnimed()
          .then(res => {
            this.listagemAnalista = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    /**
     * É chamada no botão SALVAR na modal de analistas
     * @param {
      {
        objetoAnalista:
        {
          "cdUnimed": Number,
          "email": String,
          "idUsuarioUnimed": Number,
          "login": String,
          "nome": String
        },
        tipoAcao: String
      }} objetoModal 
    */
    salvarModalAnalista(objetoModal) {
      const { objetoAnalista } = objetoModal;
      this.objetoAnalistaAtual = objetoAnalista;

      this.$store.dispatch("setMostrarModalConfirmarResumido", {
        mostrarModalConfirmar: true,
        callbackModalConfirmar: () => this.confirmarAcaoAnalista(),
        tituloModalConfirmar: "Vincular analista?",
        mensagemModalConfirmar:
          "Ao vincular um analista a Unimed, ele se tornará responsável pelas transações relacionadas a ela.",
        textoBotaoModalConfirmar: "SIM, VINCULAR"
      });
      this.$store.commit("setCallbackFecharModalConfirmar", () => {
        this.objetoAnalistaAtual = {};
      });
    },
    /**
     * É chamada no botão de confirmar na modal de ação
     */
    confirmarAcaoAnalista() {
      const params = {
        cdUnimed: this.codigoUnimed
      };
      const objetoAnalista = this.objetoAnalistaAtual;
      const { nome } = objetoAnalista;
      const { nomeUnimed } = this.objetoInformacoes;
      this.objetoAnalistaAtual = {};

      this.$store.commit("setMostrarModalConfirmar", false);
      this.$store.commit("setLoadingModal", true);

      this.putAnalistaUnimed(params, objetoAnalista)
        .then(() => {
          this.$store.commit(
            "setSubtituloSucesso",
            `O analista ${nome}, agorá é \n responsável por toda ${nomeUnimed}.`
          );
          this.$store.commit("setMostrarSucessoModal", true);
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.carregarDetalhes();
          });
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    /**
     * É chamada no botão de adicionar ou editar analista no cartão com as informações
     */
    abrirModalAnalista() {
      this.mostrarModalAnalista = true;
    },

    // CONTATOS
    /**
     * Função inicializadora da listagem de contatos
     * @return {Promise<null>}
     */
    inicializarContatos() {
      return new Promise((resolve, reject) => {
        this.loadingContatos = true;
        this.loadingContatosExcluidos = true;
        const params = {
          cdUnimed: this.codigoUnimed
        };
        this.getContatosUnimed(params)
          .then(res => {
            this.montarTabela(res.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            this.loadingContatos = false;
          });
        this.getContatosExcluidosUnimed(params)
          .then(res => {
            this.montarTabelaExcluidos(res.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            this.loadingContatosExcluidos = false;
          });
      });
    },
    /**
     * Método para montar a tabela de erros
     * @param {
      [
        {
          "cdUnimed": Number,
          "email": String,
          "id": Number,
          "nome": String,
          "notificacaoAtiva": Boolean,
          "telefone": String
        }
      ]
     } rows
    */
    montarTabela(rows) {
      this.listagemContatos = [];
      this.valoresSwitchProp = [];

      rows.forEach(e => {
        const { nome, email, id, notificacaoAtiva, telefone } = e;
        this.valoresSwitchProp.push(notificacaoAtiva);
        const objetoLinha = {
          nome,
          email,
          telefone: this.mascaraTelefone(telefone),
          notificacao: {
            mostrarSwitch: true,
            valorSwitch: notificacaoAtiva,
            textoVerdadeiro: "Ativo",
            textoFalso: "Inativo"
          },
          naoMostrar: {
            naoAparece: true,
            id
          }
        };
        this.listagemContatos.push(objetoLinha);
      });
    },
    montarTabelaExcluidos(rows) {
      this.listagemContatosExcluidos = [];
      this.valoresSwitchProp = [];

      rows.forEach(e => {
        const { nome, email, id, usuarioExclusao, dataExclusao, telefone } = e;
        const objetoLinha = {
          nome,
          email,
          usuarioExclusao,
          dataExclusao: dataExclusao
            ? this.$helpers.formatadorHorario(dataExclusao)
            : " - ",
          naoMostrar: {
            naoAparece: true,
            id,
            telefone: this.mascaraTelefone(telefone)
          }
        };
        this.listagemContatosExcluidos.push(objetoLinha);
      });
    },
    /**
     * Abre a modal de contatos com a ação de adicionar
     */
    abrirModalAdicionar() {
      this.tipoAcaoModalContatos = "ADICIONAR";
      this.mostrarModalContatos = true;
    },
    /**
     * Abre a modal de contatos com a ação de editar
     */
    abrirModalEditar(id) {
      this.tipoAcaoModalContatos = "EDITAR";
      this.recuperarContato(id).then(res => {
        const {
          email,
          nome,
          notificacaoAtiva,
          telefone,
          id,
          admUnimedContatosHistoricos
        } = res;
        const objetoContato = {
          nome,
          email,
          telefone: this.mascaraTelefone(telefone),
          notificacaoAtiva,
          id,
          admUnimedContatosHistoricos
        };
        this.$refs["modal-acao-contatos"].editarObjetoContato(objetoContato);
        this.mostrarModalContatos = true;
      });
    },
    abrirModalMotivoExclusao(id) {
      this.tipoAcaoModalContatos = "EXCLUIR";
      this.recuperarContato(id).then(res => {
        const {
          email,
          nome,
          notificacaoAtiva,
          telefone,
          id,
          usuarioExclusao,
          dataExclusao,
          admUnimedContatosHistoricos
        } = res;
        const objetoContato = {
          nome,
          email,
          telefone: this.mascaraTelefone(telefone),
          notificacaoAtiva,
          id,
          usuarioExclusao,
          dataExclusao,
          admUnimedContatosHistoricos
        };
        this.$refs["modal-acao-contatos"].editarObjetoContato(objetoContato);
        this.mostrarModalContatos = true;
      });
    },
    /**
      * Recupera os dados de um contato
      * @param { Number } idContato
      * @return { Promise<{
        "cdUnimed": Number,
        "email": String,
        "id": Number,
        "nome": String,
        "notificacaoAtiva": Boolean,
        "telefone": String,
        "admUnimedContatosHistoricos": Array
      }
      >}
    */
    recuperarContato(idContato) {
      return new Promise(resolve => {
        this.$store.commit("setLoadingModal", true);
        this.getContatoUnimed(idContato)
          .then(res => {
            resolve(res.data);
          })
          .finally(() => {
            this.$store.commit("setLoadingModal", false);
          });
      });
    },
    /**
      * Método utilizado para salvar um contato
      * @param {
        {
          email: String
          nome: String
          telefone: String
          notificacaoAtiva: false,
          admUnimedContatosHistoricos: []
        }} objetoContato 
    */
    adicionarContato(objetoContato) {
      this.mostrarModalContatos = false;
      this.$store.commit("setLoadingModal", true);

      const params = {
        cdUnimed: this.codigoUnimed
      };

      this.postContatosUnimed(params, objetoContato)
        .then(() => {
          this.$store.commit(
            "setSubtituloSucesso",
            `Os dados para notificações foram atualizados.`
          );
          this.$store.commit("setMostrarSucessoModal", true);
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.inicializarContatos();
          });
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    /**
      * Método utilizado para editar um contato
      * @param {
        {
          email: String
          nome: String
          telefone: String
          notificacaoAtiva: Boolean,
          id: Number
        }} objetoContato 
    */
    editarContato(objetoContato) {
      this.mostrarModalContatos = false;
      this.$store.commit("setLoadingModal", true);
      const { id } = objetoContato;

      this.putContatosUnimed(id, objetoContato)
        .then(() => {
          this.$store.commit(
            "setSubtituloSucesso",
            `Os dados para notificações foram atualizados.`
          );
          this.$store.commit("setMostrarSucessoModal", true);
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.inicializarContatos();
          });
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    abrirModalHistorico(id) {
      this.recuperarHistorico(id)
        .then(res => {
          this.$refs["modal-historicos"].montarTabela(res.data, id);
          this.mostrarModalHistoricos = true;
        })
        .finally(() => {});
    },
    recuperarHistorico(id) {
      return axios.get(
        this.CriarUrl({ resource: `adm/unimeds/contatos/historico/${id}` })
      );
    },
    /**
     * É chamada na ação de excluir na tabela de contatos e abre a modal de confirmação de exclursão
     * @param {Number} id
     */
    excluirContato(id) {
      this.$store.dispatch("setMostrarModalConfirmarResumido", {
        mostrarModalConfirmar: true,
        callbackModalConfirmar: () => this.confirmarExclursao(id),
        tituloModalConfirmar: "Excluir este contato?",
        mensagemModalConfirmar:
          "A exclusão desse contato não poderá ser revertida.",
        textoBotaoModalConfirmar: "EXCLUIR",
        tipoBotaoModalConfirmar: "importante"
      });
    },
    confirmarExclursao(id) {
      this.$store.commit("setMostrarModalConfirmar", false);
      this.abrirModalMotivoExclusao(id);
    },
    /**
      * É chamada depois que é cliqueado ou no botão de adicionar ou editar na tabela de contatos
      * @param {
        {
          email: String
          nome: String
          telefone: String
          notificacaoAtiva: Boolean,
          id: Number
        }} objetoContato 
    */
    salvarContatos(objetoContato) {
      if (this.tipoAcaoModalContatos === "ADICIONAR") {
        this.adicionarContato(objetoContato);
      } else {
        this.editarContato(objetoContato);
      }
    },
    /**
     * Método que pega o index e o valor atual do switch
     * @param {{ index: Number, value: Boolean }} objetoSwitch
     */
    editarNotificacao(objetoSwitch) {
      const dataAtual = new Date();
      dataAtual.setUTCHours(dataAtual.getUTCHours() - 3);
      const { value, index } = objetoSwitch;
      const objetoContato = this.listagemContatos[index];
      const { id } = objetoContato.naoMostrar;
      const objetoContatoTemp = {
        notificacaoAtiva: value,
        admUnimedContatosHistoricos: [
          {
            nomeUsuarioAlteracao: this.nomeUsuarioMixin,
            dataAlteracao: dataAtual,
            acao: "Alteração",
            motivoAlteracao: "Alteração de Status",
            nomeCampoAlterado: "Notificação",
            valorAntigoCampo: !value === true ? "Ativo" : "Inativo",
            valorNovoCampo: value === true ? "Ativo" : "Inativo"
          }
        ]
      };
      this.$store.commit("setLoadingModal", true);

      this.patchContatosUnimedNotificacao(id, objetoContatoTemp)
        .then(() => {
          this.$store.commit(
            "setSubtituloSucesso",
            `O dado da notificação foi alterado.`
          );
          this.$store.commit("setMostrarSucessoModal", true);
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.inicializarContatos();
          });
        })
        .catch(() => {
          this.$set(this.valoresSwitchProp, index, !value);
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },

    // OBSERVAÇÕES

    /**
     * Método inicializador de observações
     * @return {Promise<null>}
     */
    inicializarObservacoes() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("inicializarObservacaoStore")
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    }
  },
  computed: {
    quantidadeObservacoes() {
      return this.$store.getters.getTotalObservacao;
    },
    mostrarModalEdicao: {
      set(value) {
        this.$store.commit("setMostrarModalEdicao", value);
      },
      get() {
        return this.$store.getters.getMostrarModalEdicao;
      }
    }
  }
};
